import React from 'react';
import styled from 'styled-components';
import LockIcon from '#app/assets/icons/lock.svg';

const LockIconContainer = styled.div`
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 16px;
  height: 16px;
  background-color: #EFF2F5;
  border-radius: 50%;
  z-index: 1;
`;

const LockIconImage = styled.img`
  width: 12px;
  height: 12px;
  display: block;
  margin: 0;
`;

interface RepoLockIconProps {
  className?: string;
}

export const RepoLockIcon: React.FC<RepoLockIconProps> = ({ className }) => {
  return (
    <LockIconContainer className={className}>
      <LockIconImage src={LockIcon} alt="REPO locked" />
    </LockIconContainer>
  );
};

export default RepoLockIcon;

